import { render, staticRenderFns } from "./BBPendingTransfers.vue?vue&type=template&id=17b0f540&lang=pug"
import script from "./BBPendingTransfers.vue?vue&type=script&lang=js"
export * from "./BBPendingTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports